import getOne from 'utils/getOne'

const loadRecord = async (url: string, id: number | string, extend: String[] | undefined) => {
  const retData = await getOne(url, id, extend).then((data) => {
    const loadedData = {
      ...data,
    }

    return loadedData
  })

  return retData
}

export default loadRecord
